import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

function Exit({ width = 20, height = 20, color = '#fff', className, ...rest }: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z"
        fill={color}
      />
    </svg>
  );
}

export default Exit;
